import { bl_svc_issue_event_RowCLass } from '../../../dbschema/bl_svc_issue_event.model';
import { BaseContainerModel } from '../../base-container.model';


export class ServiceNoteEventContainerModel extends BaseContainerModel {
  bl_svc_issue_event: bl_svc_issue_event_RowCLass = new bl_svc_issue_event_RowCLass();
}
